var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--grey-500)",
    fillRule: "evenodd",
    d: "M18.707 1.13a1 1 0 0 1 .236 1.04l-6 17a1 1 0 0 1-1.811.163l-3.865-6.764L.504 8.705a1 1 0 0 1 .163-1.812l17-6a1 1 0 0 1 1.04.236ZM3.393 8.051l5.103 2.916a1 1 0 0 1 .372.372l2.916 5.103 4.577-12.968L3.393 8.052Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.46c4f4e73178fe11b7792c92e4d086d4.svg";
export { ForwardRef as ReactComponent };